import { Component, OnInit } from '@angular/core';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';
import { Utilisateur } from 'src/app/classes/utilisateur';
import { Droit } from '../../classes/droit';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css'],
  providers : [ConfirmationService]
})
export class AdministrationComponent implements OnInit {
  tableCols: any[];
  userList: Utilisateur[];
  modalVisible: boolean;
  data: Utilisateur;

  constructor(private userService : UtilisateursService, private confirmService : ConfirmationService) { }

  ngOnInit(): void {
    this.userList = null;
    this.loadAllUtlisateur();
    this.tableCols = [
      {field: 'matricule', header: 'Matricule'},
      {field: 'nom', header: 'Nom'},
      {field: 'prenom', header: 'Prénom'},
      {field: 'email', header: 'Mail'},
      {field: 'droit', header: 'Droit'},
    ];
    this.modalVisible = false;
  }
  loadAllUtlisateur(): void {
    this.userList = [];
    this.userService.getAllListUtilisateur('').subscribe(data => {
      const listeUtilisateur = data['listeutilisateur'];
      for (let i = 0; i < listeUtilisateur.length; i++ ) {
        const objet_utilisateurAsset = listeUtilisateur[i];
        if (objet_utilisateurAsset) {
          console.log(objet_utilisateurAsset);
          const utilisateurTemp = new Utilisateur(objet_utilisateurAsset.id_utilisateur,
            objet_utilisateurAsset.nom,
            objet_utilisateurAsset.prenom,
            objet_utilisateurAsset.designation_droit,
            objet_utilisateurAsset.matricule,
            objet_utilisateurAsset.mdp,
            objet_utilisateurAsset.email,
            new Droit(objet_utilisateurAsset.id_droit, objet_utilisateurAsset.designation_droit));
          this.userList.push(utilisateurTemp);
        }
      }
    });
  }

  showModal(user: Utilisateur = undefined) {
    this.data = {
      id: 0,
      nom: '',
      prenom: '',
      droit: '',
      matricule: 0,
      mot_de_passe: '',
      email: '',
      droit_object: new Droit(0, ''),
    };
    if(user !== undefined) {
      this.data = user;
    }
    this.modalVisible = true;
  }

  confirmReinit(user:Utilisateur) {
    this.confirmService.confirm({
      message:'Etes-vous sûr de vouloir réinitialiser le mot de passe du matricule ' + user.matricule + '?',
      accept : () => {
        this.userService.reinitPass(user.matricule).subscribe( value => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + value["cause"]);
          }else {
            alert('Le mot de passe generé est ' + value['data']);
          }
        })
      }
    });
  }
}
